import React from 'react';
import {Pressable, StyleSheet, View} from 'react-native';
import CheckBoxChecked from 'src/components/img/svg/CheckBoxChecked';
import CheckBoxUnchecked from 'src/components/img/svg/CheckBoxUnchecked';
import RadioChecked from 'src/components/img/svg/RadioChecked';
import RadioUnchecked from 'src/components/img/svg/RadioUnchecked';
import Styles from 'src/components/Styles';
import Settings from 'src/Settings';

const selectedColors = {
  default: {
    color: Styles.Colors.PayNew.primary01,
  },
  refive: {
    color: Styles.Colors.PayNew.primary01,
  },
  canteen: {
    color: Styles.Colors.Canteen.darkGreen,
  },
  companykitchen: {
    color: Styles.Colors.CompanyKitchen.blue,
  },
};

export enum CustomToggleComponentType {
  Checkbox = 'checkbox',
  Radio = 'radio',
}

const CustomToggleComponent = ({
  type = 'checkbox',
  selected = false,
  onPress,
  accessibilityLabel = {},
  testID = '',
}) => {
  const images = {
    checkbox: {
      checked: (
        <CheckBoxChecked fillColor={selectedColors[Settings.buildType].color} />
      ),
      unchecked: <CheckBoxUnchecked />,
    },
    radio: {
      checked: (
        <RadioChecked color={selectedColors[Settings.buildType].color} />
      ),
      unchecked: <RadioUnchecked />,
    },
  };

  // Determine the image based on type and checked state
  const selectedImage = selected
    ? images[type].checked
    : images[type].unchecked;

  return (
    <Pressable
      onPress={onPress}
      accessible
      accessibilityLabel={`${type} ${accessibilityLabel}`}
      testID={testID}
      hitSlop={Styles.HitSlop_10}
      nativeID={`${type} ${accessibilityLabel}`}
    >
      <View
        accessible
        aria-label={`${type} ${accessibilityLabel}`}
        accessibilityLabel={`${type} ${accessibilityLabel}`}
        role="button"
        accessibilityHint={`${type} ${accessibilityLabel}`}
        style={styles.buttonContainer}
      >
        {selectedImage}
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    flex: 1,
    alignItems: 'center',
  },
});

export default CustomToggleComponent;
